import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAmbassadorReferralAction } from "../../../redux/actions/referrals";
import useCommonParams from "../../../hooks/useCommonParams";

export default function useGetAmbassadorsReferallsQuery(enabled = true) {
  const dispatch = useDispatch();

  const { AmbassadorReferrals, isAmbassadorLoading, totalAmbassadorRecords } =
    useSelector((state) => state.referrals);

  const { queryParams } = useCommonParams();

  useEffect(() => {
    if (enabled) {
      dispatch(getAmbassadorReferralAction(queryParams));
    }
  }, [queryParams, enabled]);

  return {
    AmbassadorReferrals,
    totalAmbassadorRecords,
    isAmbassadorLoading,
  };
}
